import { ConvertcustomerGender, isValidDate } from '@/utils/helpers';
import React, { Component } from 'react';

class PrintGeneralExamForm extends Component {

    render() {
        const { customer, diseases } = this.props;

        const safeTrim = (value) => {
            if (typeof value === "string") return value.trim();
            return "";
        };

        const addressParts = [
            safeTrim(customer?.address),
            safeTrim(customer?.hamlet),
            safeTrim(customer?.wards_name),
            safeTrim(customer?.province_name),
        ];

        // Lọc bỏ phần rỗng và nối lại
        const address = addressParts.filter(part => part !== "").join(", ");

        const reasons = [
            { value: "chinh_nha", label: "Chỉnh nha" },
            { value: "implant", label: "Implant" },
            { value: "tham_my_rang", label: "Thẩm mỹ răng" },
            { value: "kham_va_vsrm", label: "Khám và VSRM tổng quát" },
            { value: "dau_rang", label: "Đau răng" },
            { value: "nho_rang", label: "Nhổ răng" }
        ];

        const tinh_trang_rang = [
            { value: "level_1", label: "Level 1" },
            { value: "level_2", label: "Level 2" },
            { value: "level_3", label: "Level 3" }
        ];

        const mau_sac_rang = [
            { value: "nhiem_tetra", label: "Nhiễm tetra" },
            { value: "nhiem_flour", label: "Nhiễm flour" },
            { value: "mau_trang", label: "Bình thường" }
        ];

        const dieu_tri_khac = [
            { label: "Lấy cao răng", value: "lay_cao_rang" },
            { label: "Điều trị viêm lợi", value: "dieu_tri_viem_loi" },
            { label: "Tẩy trắng răng", value: "tay_trang" }
        ];

        const renderDot = (value, dot = ".................................................") => {
            if (value === null || value === undefined || value === "") {
                return dot;
            }
            return value;
        };

        return (
            <div className="container print-content">
                <div className='page-break'>
                    <div className="title-wrap">
                        <div className="print-date-top">
                            Ngày.........tháng.........năm.........
                        </div>
                        <h1>PHIẾU KHÁM TỔNG QUÁT RĂNG MIỆNG</h1>
                    </div>
                    <table className="kv-table">
                        <tr>
                            <td><strong>Họ tên: {renderDot(customer?.full_name)}</strong> </td>
                            <td><strong>Mã khách hàng: </strong> {renderDot(customer?.code)}</td>
                        </tr>

                        <tr>
                            <td><strong>Số căn cước: </strong> {renderDot(customer?.identity_number)}</td>
                            <td><strong>Nguồn: </strong> {renderDot(customer?.source)}</td>
                        </tr>

                        <tr>
                            <td><strong>Ngày sinh: </strong> {renderDot(isValidDate(customer?.birthday, false))}</td>
                            <td><strong>NV tư vấn 1: </strong> {renderDot(null)}</td>
                        </tr>

                        <tr>
                            <td>
                                <strong>Giới tính: </strong>
                                {
                                    customer?.gender
                                        ? ConvertcustomerGender(customer?.gender)
                                        : (
                                            <>
                                                <label style={{ marginRight: 12 }}>
                                                    <input type="checkbox" className="checkbox" /> Nam
                                                </label>
                                                <label>
                                                    <input type="checkbox" className="checkbox" /> Nữ
                                                </label>
                                            </>
                                        )
                                }
                            </td>

                            <td><strong>NV tư vấn 2: </strong> {renderDot(null)}</td>
                        </tr>
                        <tr>
                            <td colSpan={2}><strong>Địa chỉ: </strong> {renderDot(address)}</td>
                        </tr>

                    </table>

                    <h2 className="section-title">I. LÝ DO ĐẾN KHÁM</h2>
                    <div className="checkbox-inline-row">
                        {reasons.map((opt, index) => {
                            return (
                                <>
                                    <div key={index} className="inline-item">
                                        <label className="inline-checkbox">
                                            <input type="checkbox" className="checkbox" /> {opt.label}
                                        </label>
                                    </div>
                                </>
                            );
                        })}
                    </div>
                    <div className="field-wrapper">
                        <span className="label">Lý do khác:</span>
                        <div className="dot-line"></div>
                    </div>
                    <div className="field-wrapper">
                        <span className="label">Mong muốn của khách hàng:</span>
                        <div className="dot-line"></div>
                    </div>

                    <h2 className="section-title">II. BỆNH LÝ CẦN LƯU Ý</h2>
                    <div className="grid-cols">
                        <div className="col">
                            {diseases.slice(0, 11).map((item, index) => (
                                <div className="row item-row" key={item.id}>
                                    <div className="name">
                                        <div className="name">
                                            {index + 1}.{" "}

                                            {item.name === "Khác"
                                                ? item.name + " ....................................................................."
                                                : item.name}
                                        </div>
                                    </div>
                                    <div className="check">
                                        {item.name === "Khác" ? (
                                            <></>
                                        ) : (
                                            <>
                                                <input type="checkbox" className="checkbox" /> Có &nbsp;
                                                <input type="checkbox" className="checkbox" /> Không
                                            </>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="col">
                            {diseases.slice(11).map((item, index) => (
                                <div className="row item-row" key={item.id}>
                                    <div className="name">
                                        {index + 12}.{" "}

                                        {item.name === "Khác"
                                            ? item.name + " ....................................................................."
                                            : item.name}
                                    </div>
                                    <div className="check">
                                        {item.name === "Khác" ? (
                                            <></>
                                        ) : (
                                            <>
                                                <input type="checkbox" className="checkbox" /> Có &nbsp;
                                                <input type="checkbox" className="checkbox" /> Không
                                            </>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <h2 className="section-title">III. KHÁM TỔNG QUÁT RĂNG MIỆNG</h2>
                    <img src="/stm_4.2.jpg" style={{ width: 'auto', height: 300, display: 'block', margin: '0 auto' }} alt="Sơ đồ STM 4.2" />

                    <div className="mt-2"><strong>Tình trạng cao răng:</strong></div>
                    <div className="checkbox-inline-row">
                        {tinh_trang_rang.map((opt, index) => {
                            return (
                                <>
                                    <div key={index} className="inline-item">
                                        <label className="inline-checkbox">
                                            <input type="checkbox" className="checkbox" /> {opt.label}
                                        </label>
                                    </div>
                                </>
                            );
                        })}
                    </div>
                </div>

                <div className='page-break'>
                    <div className="field-wrapper">
                        <span className="label">Tình trạng nướu (lợi):</span>
                        <div className="dot-line"></div>
                    </div>
                    <div className="dotted-lines">
                        <div className="line"></div>
                    </div>

                    <div className="mt-2"><strong>Màu sắc răng:</strong></div>
                    <div className="checkbox-inline-row">
                        {mau_sac_rang.map((opt, index) => {
                            return (
                                <>
                                    <div key={index} className="inline-item">
                                        <label className="inline-checkbox">
                                            <input type="checkbox" className="checkbox" /> {opt.label}
                                        </label>
                                    </div>
                                </>
                            );
                        })}
                    </div>

                    <div className="field-wrapper">
                        <span className="label">Tình trạng răng khôn:</span>
                        <div className="dot-line"></div>
                    </div>
                    <div className="dotted-lines">
                        <div className="line"></div>
                    </div>

                    <div className="mt-2"><strong>Tình trạng khớp cắn:</strong></div>
                    <div className="form-section mt-2">
                        {/* 1. Đau khớp */}
                        <div className="full item-row">
                            <div className="label">
                                Khớp cắn / khớp thái dương có triệu chứng đau?
                            </div>
                            <div className="field">
                                <input type="checkbox" className="checkbox" /> Có &nbsp;
                                <input type="checkbox" className="checkbox" /> Không
                            </div>
                        </div>

                        {/* 2. Phát tiếng kêu */}
                        <div className="full item-row">
                            <div className="label">
                                Khớp cắn / khớp thái dương có phát tiếng kêu khi há / đóng miệng tối đa?
                            </div>
                            <div className="field">
                                <input type="checkbox" className="checkbox" /> Có &nbsp;
                                <input type="checkbox" className="checkbox" /> Không
                            </div>
                        </div>

                        {/* 3. Đường há zích-zắc */}
                        <div className="full item-row">
                            <div className="label">
                                Đường há ngậm miệng có dạng zích-zắc?
                            </div>
                            <div className="field">
                                <input type="checkbox" className="checkbox" /> Có &nbsp;
                                <input type="checkbox" className="checkbox" /> Không
                            </div>
                        </div>
                    </div>

                    <h2 className="section-title">IV. CHẨN ĐOÁN TRÊN PHIM X-QUANG</h2>
                    <div className="dotted-lines">
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                    </div>

                    <h2 className="section-title">V. CHẨN ĐOÁN SƠ BỘ</h2>
                    <div className="dotted-lines">
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                    </div>

                    <h2 className="section-title">VI. HƯỚNG ĐIỀU TRỊ</h2>
                    <div className="field-wrapper">
                        <span className="label">Lấy cao răng, điều trị viêm lợi:</span>
                        <div className="dot-line"></div>
                    </div>
                    <div className="dotted-lines">
                        <div className="line"></div>
                    </div>

                    <div className="field-wrapper">
                        <span className="label">Trám các răng:</span>
                        <div className="dot-line"></div>
                    </div>
                    <div className="dotted-lines">
                        <div className="line"></div>
                    </div>

                    <div className="field-wrapper">
                        <span className="label">Điều trị tủy các răng:</span>
                        <div className="dot-line"></div>
                    </div>
                    <div className="dotted-lines">
                        <div className="line"></div>
                    </div>

                    <div className="field-wrapper">
                        <span className="label">Trồng các răng:</span>
                        <div className="dot-line"></div>
                    </div>
                    <div className="dotted-lines">
                        <div className="line"></div>
                    </div>

                    <div className="field-wrapper">
                        <span className="label">Làm cầu, chụp:</span>
                        <div className="dot-line"></div>
                    </div>
                    <div className="dotted-lines">
                        <div className="line"></div>
                    </div>

                    <div className="field-wrapper">
                        <span className="label">Nhổ răng:</span>
                        <div className="dot-line"></div>
                    </div>
                    <div className="dotted-lines">
                        <div className="line"></div>
                    </div>

                    <div className="mt-2"><strong>Chăm sóc và điều trị khác:</strong></div>
                    <div className="checkbox-inline-row">
                        {dieu_tri_khac.map((opt, index) => {
                            return (
                                <>
                                    <div key={index} className="inline-item">
                                        <label className="inline-checkbox">
                                            <input type="checkbox" className="checkbox" /> {opt.label}
                                        </label>
                                    </div>
                                </>
                            );
                        })}
                    </div>

                    <div className="field-wrapper">
                        <span className="label">Chỉ định khác:</span>
                        <div className="dot-line"></div>
                    </div>
                    <div className="dotted-lines">
                        <div className="line"></div>
                    </div>

                    <div className="field-wrapper">
                        <span className="label">Chi tiết chỉ định:</span>
                        <div className="dot-line"></div>
                    </div>
                    <div className="dotted-lines">
                        <div className="line"></div>
                        <div className="line"></div>
                    </div>
                </div>
                <div className='page-break'>
                    <div className="field-wrapper">
                        <span className="label">VII. NỘI DUNG TƯ VẤN (dành cho nhân viên tư vấn):</span>
                        <div className="dot-line"></div>
                    </div>
                    <div className="dotted-lines">
                        {Array.from({ length: 35 }).map((_, index) => (
                            <div key={index} className="line"></div>
                        ))}
                    </div>

                    <div className="signature-section mt-4">
                        <div className="sig-box">
                            <strong>CHUYÊN VIÊN TƯ VẤN</strong>
                            <span className="note">(Ký, ghi rõ họ tên)</span>
                            <div className="sig-space"></div>
                            <div className="sig-name"></div>
                        </div>
                        <div className="sig-box">
                            <strong>KHÁCH HÀNG</strong>
                            <span className="note">(Ký, ghi rõ họ tên)</span>
                            <div className="sig-space"></div>
                            <div className="sig-name"></div>
                        </div>
                        <div className="sig-box">
                            <strong>BÁC SỸ</strong>
                            <span className="note">(Ký, ghi rõ họ tên)</span>
                            <div className="sig-space"></div>
                            <div className="sig-name"></div>
                        </div>
                    </div>
                </div>


                <style>
                    {`
                        /* --- Print & Page setup --- */
                        @page {
                            size: A4;
                            margin: 1cm 0.5cm 1cm 0.5cm; /* top, right, bottom, left */
                        }

                        :root {
                            --text: #111;
                            --muted: #666;
                            --border: #ddd;
                            --heading: #000;
                            --primary: #0b2b33;
                        }

                        @media print {
                            .no-print {
                                display: none !important;
                            }

                            .page-break {
                                page-break-before: always;
                            }

                            body {
                                font-family: "Times New Roman", serif;
                                font-size: 12pt;
                                line-height: 1.5;
                                color: #000;
                               /*  width: 210mm;
                                border: 1px solid #dedede; */
                            }
                            .print-date-top{
                                margin-top: -5mm;
                            }
                        }

                        .print-date-top{
                            margin-bottom: 10px;
                            text-align: right;
                            font-style: italic;
                        }
                        .field-wrapper {
                            display: flex;
                            align-items: center;
                            width: 100%;
                        }

                        .field-wrapper .label {
                            font-weight: 600;  /* theo style subtitle của bạn */
                            margin-right: 0;
                            white-space: nowrap;
                        }

                        .field-wrapper .dot-line {
                            flex: 1;
                            border-bottom: 1px dotted #000;
                            height: 1px;
                            margin-top: 8px; /* căn cho đẹp */
                        }

                        .dotted-lines .line {
                            border-bottom: 1px dotted #000;
                            height: 16px;       /* chiều cao mỗi dòng */
                            margin-bottom: 6px; /* khoảng cách giữa các dòng */
                            width: 100%;
                        }

                        .checkbox-inline-row {
                            display: flex;
                            align-items: center;
                            flex-wrap: nowrap;
                            width: 100%;
                            margin-bottom: 6px;
                        }

                        .inline-label {
                            margin-right: 10px;
                            white-space: nowrap;
                        }

                        .inline-item {
                            display: flex;
                            align-items: center;
                            gap: 10px;
                            white-space: nowrap;
                            margin-right: 10px;
                        }

                        .inline-checkbox {
                            display: flex;
                            align-items: center;
                            white-space: nowrap;
                        }

                        .checkbox {
                            width: 15px;
                            height: 15px;
                            margin-right: 6px;
                        }

                        .inline-dots {
                            display: flex;
                            flex-direction: column;
                            flex-grow: 1;
                        }

                        .dotline {
                            border-bottom: 1px dotted #000;
                            height: 16px;
                            display: block;
                            margin-top: -6px;
                            width: 100%;
                        }

                        /* container 2 cột giống Row + Col */
                        .grid-cols {
                            display: grid;
                            grid-template-columns: 1fr 1fr;
                            gap: 16px 32px; /* dọc 16, ngang 32 */
                        }

                        /* Khi màn nhỏ như xs={24}, tự xuống 1 cột */
                        @media (max-width: 576px) {
                            .grid-cols {
                                grid-template-columns: 1fr;
                            }
                        }

                        /* giống Row align="middle" */
                        .item-row {
                            display: flex;
                            align-items: center;
                        }

                        /* giống Col flex="auto" */
                        .item-row .name {
                            flex: 1;
                        }

                        /* giống Col cố định */
                        .item-row .check {
                            flex-shrink: 0;
                        }

                        /* Gutter giống Row gutter={8} */
                        .form-section > .full {
                            margin-bottom: 8px;
                        }

                        /* Row align="middle" */
                        .item-row {
                            display: flex;
                            align-items: center;
                        }

                        /* Col flex="auto" */
                        .item-row .label {
                            flex: 1;
                            padding-right: 8px;
                        }

                        /* Col cố định */
                        .item-row .field {
                            flex-shrink: 0;
                        }

                        .print-content .dot {
                            display: inline-block;
                            border-bottom: 1px dotted #444;
                            width: 100%;
                            height: 16px;
                            vertical-align: middle;
                        }

                        .dot-full {
                            display: inline-block;
                            border-bottom: 1px dotted #333;
                            width: 100%;
                            height: 18px; /* chiều cao dòng viết tay */
                            vertical-align: middle;
                        }
                        .container {
                            max-width: 800px;
                            margin: 0 auto;
                            padding: 0;
                            position: relative;
                        }

                        .print-content h1,
                        .print-content h2,
                        .print-content h3 {
                            margin: 0 0 10px 0;
                            color: var(--heading);
                        }

                        .print-content h1 {
                            text-align: center;
                            font-size: 18pt;
                            letter-spacing: 0.3px;
                        }

                        .print-content h2.section-title {
                            font-size: 11pt;
                            margin: 4px 0;
                        }

                        .print-content .line-height-20{
                            line-height: 20px;
                        }
                        .subtitle {
                            color: var(--muted);
                            font-style: italic;
                            font-weight: normal;
                            margin-left: 6px;
                            font-size: 11.5pt;
                        }

                         /* --- Header --- */
                    .header {
                        display: flex;
                        align-items: flex-start;
                        justify-content: space-between;
                        margin-bottom: 20px;
                        border-bottom: 1px solid var(--border);
                        padding-bottom: 20px;
                        position: relative;
                    }

                    /* Nhóm bên phải (QR + thông tin) */
                    .header .footer {
                        display: flex;
                        align-items: flex-start;
                        gap: 16px;
                        border: none;
                        padding-top: 0;
                        margin-top: 0;
                    }

                    /* Logo */
                    .logo-box {
                        width: 90px;
                        height: 90px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;
                    }

                    .logo-box img {
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: contain;
                    }

                    /* QR */
                    .header .footer .qr-box {
                        width: 80px;
                        height: 80px;
                        flex-shrink: 0;
                    }

                    .header .footer .qr-box img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                        border: 1px solid var(--border);
                        background: #fff;
                        padding: 4px;
                    }

                    /* Clinic info */
                    .header .footer .clinic {
                        text-align: left;
                        margin-left: 8px;
                        font-size: 10.5pt;
                        line-height: 1.4;
                    }

                    .header .footer .clinic .section-title {
                        font-weight: bold;
                        color: var(--primary);
                        margin-bottom: 4px;
                        font-size: 11pt;
                    }

                    .header .footer .clinic span {
                        display: block;
                        font-size: 8px;
                        color: var(--muted);
                        line-height: 1.3;
                    }
                        .title-wrap {
                            margin: 8px 0 16px 0;
                            position: relative;
                        }

                        /* --- Tables --- */
                        table {
                            border-collapse: collapse;
                            width: 100%;
                        }

                        .kv-table td,
                        .kv-table th {
                            border: 0px solid var(--border);
                            padding: 5px 0px;
                            vertical-align: top;
                        }

                        .kv-table th {
                            width: 20%;
                            text-align: left;
                            font-weight: 600;
                        }

                        .grid-table th,
                        .grid-table td {
                            border: 1px solid var(--border);
                            padding: 6px 8px;
                            vertical-align: top;
                        }

                        .grid-table th {
                            background: #fafafa;
                        }

                        .narrow td,
                        .narrow th {
                            padding: 5px 6px;
                        }

                        .muted {
                            color: var(--muted);
                        }

                        /* --- Helpers --- */
                        .mb-4 {
                            margin-bottom: 16px;
                        }

                        .mb-2 {
                            margin-bottom: 8px;
                        }

                        .mt-2 {
                            margin-top: 8px;
                        }

                        .mt-4 {
                            margin-top: 16px;
                        }

                        .pt-2 {
                            padding-top: 8px;
                        }

                        .pt-4 {
                            padding-top: 16px;
                        }

                        .pl-2 {
                            padding-left: 8px;
                        }

                        .pl-4 {
                            padding-left: 16px;
                        }

                        .pr-2 {
                            padding-right: 8px;
                        }

                        .pr-4 {
                            padding-right: 16px;
                        }

                        .italic {
                            font-style: italic;
                        }

                        .center {
                            text-align: center;
                        }

                        .right {
                            text-align: right;
                        }

                        .checkbox {
                            font-family: "Segoe UI Symbol", "DejaVu Sans", "Times New Roman";
                        }

                        .note {
                            color: var(--muted);
                        }

                        .image-strip {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 8px;
                            border: 1px dashed var(--border);
                            padding: 10px;
                            min-height: 48px;
                        }

                        .image-thumb {
                            width: 110px;
                            height: 85px;
                            border: 1px solid var(--border);
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 10pt;
                            color: var(--muted);
                            background: #fff;
                        }

                        /* --- Textareas-like blocks --- */
                        .textblock {
                            min-height: 64px;
                            border: 1px solid var(--border);
                            padding: 8px;
                            white-space: pre-wrap;
                        }

                        .textblock.tall {
                            min-height: 96px;
                        }

                        .disease-grid {
                            display: flex;
                            gap: 16px;
                            justify-content: space-between;
                        }

                        .disease-column {
                            flex: 1;
                        }

                        .disease-column table {
                            width: 100%;
                        }

                        .disease-column td strong {
                            margin-right: 4px;
                            color: var(--primary);
                        }

                        @media print {
                            .disease-grid {
                                page-break-inside: avoid;
                            }
                        }

                        .bite-item {
                            justify-content: space-between;
                            padding: 6px 0;
                        }

                        .bite-item:last-child {
                            border-bottom: none;
                        }

                        .bite-label {
                            flex: 1;
                            color: var(--text);
                        }

                        .bite-value {
                            min-width: 60px;
                            text-align: right;
                            font-weight: bold;
                            color: var(--primary);
                        }

                        .section-subtitle {
                            font-size: 12.5pt;
                            margin-bottom: 6px;
                        }

                        .print-date {
                            text-align: right;
                            margin-top: 40px;
                            font-size: 12pt;
                            font-style: italic;
                            color: var(--text);
                        }

                        .signature-section {
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-start;
                            margin-top: 30px;
                            text-align: center;
                            gap: 60px;
                            margin-bottom: 50px;
                        }

                        .sig-box {
                            flex: 1;
                        }

                        .sig-box strong {
                            font-size: 13pt;
                            display: block;
                            margin-bottom: 2px;
                        }

                        .sig-box .note {
                            color: var(--muted);
                            font-style: italic;
                            font-size: 11pt;
                        }

                        .sig-space {
                            height: 60px;
                            margin: 24px auto 8px auto;
                            width: 80%;
                        }

                        .sig-name {
                            font-weight: bold;
                            font-size: 12pt;
                            color: var(--primary);
                            text-transform: uppercase;
                        }
                    `}
                </style>
            </div >
        );
    }
}

export default PrintGeneralExamForm;
